<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
      <el-breadcrumb-item>裁判系统</el-breadcrumb-item>
      <el-breadcrumb-item>{{ group === 1 ? '小组赛' : group === 2 ? '无组别挑战赛' : '区域决选' }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- tabs -->
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="小组赛-平板答题" name="1-A" v-if="group === 1">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">平板答题</span>。点击【开始比赛】开始</div>
        <div class="tab-desc">2、每小题发音完成后，点击【开始作答】，大屏开始倒计时</div>
        <div class="tab-desc">3、每小题倒计时结束，点击【结束作答】提交</div>
        <div class="tab-desc">4、如遇现场突发情况，可【暂停计时】或【本题作废】</div>
      </el-tab-pane>
      <el-tab-pane label="小组赛-拼字积分" name="1-B" v-if="group === 1">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">1V1积分制</span>。词语个数：2个。</div>
        <div class="tab-desc">2、确认组别，开始比赛。</div>
        <div class="tab-desc">3、点击【比赛结束】完成比赛，生成AB轮综合排名。</div>
        <div class="tab-desc">4、设置晋级人数(晋级比例60%)，进入下一轮。</div>
      </el-tab-pane>
      <el-tab-pane label="小组赛-拼字淘汰" name="1-C" v-if="group === 1">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">单轮淘汰制</span>。请先选择该场比赛的比赛组别。</div>
        <div class="tab-desc">2、如遇上一轮比赛设置错误的情况，可点击【比赛回退】按钮回退上一轮比赛。</div>
      </el-tab-pane>
      <el-tab-pane label="小组赛-拼字淘汰(手动录入)" name="1-C-1" v-if="group === 1">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">单轮淘汰制</span>。</div>
        <div class="tab-desc">2、裁判席将最终考试排名录入本系统。</div>
      </el-tab-pane>
      <el-tab-pane label="无组别Round A" name="2-A" v-if="group === 2">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">平板答题</span>。点击【开始比赛】开始</div>
        <div class="tab-desc">2、每小题发音完成后，点击【开始作答】，大屏开始倒计时</div>
        <div class="tab-desc">3、每小题倒计时结束，点击【结束作答】提交</div>
        <div class="tab-desc">4、如遇现场突发情况，可【暂停计时】或【本题作废】</div><!--和【重新计时】-->
        <div class="tab-desc">5、点击【本场比赛结束】，设置晋级人数（默认10人），生成本轮排名，结束本场比赛。</div>
      </el-tab-pane>
      <el-tab-pane label="无组别Round B" name="2-B" v-if="group === 2">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">现场1V1拼字</span>。准备就绪点击【开始比赛】按钮，系统自动生成第一轮比赛。</div>
        <div class="tab-desc">2、如遇上一轮比赛设置错误的情况，可点击“比赛回退”按钮回退上一轮比赛。</div>
      </el-tab-pane>
      <!-- <el-tab-pane label="无组别-拼字淘汰(手动录入)" name="2-B-1" v-if="group === 2">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">单轮淘汰制</span>。</div>
        <div class="tab-desc">2、裁判席将最终考试排名录入本系统。</div>
      </el-tab-pane> -->
      <!-- 城市复选-平板答题 -->
      <el-tab-pane label="区域决选-第一轮" name="3-B" v-if="group === 3">
        <div class="tab-desc">此裁判系统需配合H5答题使用。（微信小程序答题无需使用裁判系统，由选手主动控制）</div>
        <div class="tab-desc">1、点击【开始作答】，开始本题倒计时1分钟，倒计时结束后，自动提交答案。按题目顺序依次点击【开始作答】。</div>
        <div class="tab-desc">2、最后一题计时结束后，开始整场比赛最后2分钟倒计时，目的是让选手做最后的检查，以免有漏答的题目。</div>
        <div class="tab-desc">3、最后2分钟倒计时结束后，裁判宣布比赛结束，同时点击【本场比赛结束】，结束本场考试，提交试卷，完成比赛。</div>
        <!-- <span class="btn" @click="copyFn('h5')">点此复制H5答题链接</span> -->
        <!-- <div class="tab-desc"><span class="btn" @click="copyFn('answer')">点此复制答题链接</span></div> -->
        <div class="tab-desc"><span class="btn" @click="copyFn('rank')">点此复制大屏排行榜链接</span></div>
      </el-tab-pane>
      <el-tab-pane label="区域决选-第二轮" name="3-C" v-if="group === 3">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">平板答题</span>。点击【开始比赛】开始</div>
        <div class="tab-desc">2、每小题发音完成后，点击【开始作答】，大屏开始倒计时</div>
        <div class="tab-desc">3、每小题倒计时结束，点击【结束作答】提交</div>
        <div class="tab-desc">4、如遇现场突发情况，可【暂停计时】或【本题作废】</div><!--和【重新计时】-->
        <div class="tab-desc">5、点击【本场比赛结束】，设置晋级人数（默认10人），生成本轮排名，结束本场比赛。</div>
      </el-tab-pane>
      <el-tab-pane label="区域决选-第三轮" name="3-D" v-if="group === 3">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">平板答题</span>。点击【开始比赛】开始</div>
        <div class="tab-desc">2、每小题发音完成后，点击【开始作答】，大屏开始倒计时</div>
        <div class="tab-desc">3、每小题倒计时结束，点击【结束作答】提交</div>
        <div class="tab-desc">4、如遇现场突发情况，可【暂停计时】或【本题作废】</div><!--和【重新计时】-->
        <div class="tab-desc">5、点击【本场比赛结束】，设置晋级人数（默认10人），生成本轮排名，结束本场比赛。</div>
      </el-tab-pane>
      <!-- <el-tab-pane label="城市复选2022~2023赛季" name="3" v-if="group === 3">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">1V1积分制</span>。词语个数：2个。</div>
        <div class="tab-desc">2、选择考场后即可开始比赛。</div>
        <div class="tab-desc">3、点击【比赛结束】完成复选比赛，生成复选成绩。</div>
      </el-tab-pane> -->
      <el-tab-pane label="国赛资格赛" name="4" v-if="group === 4">
        <div class="tab-desc">1、本轮考试形式为：<span class="exam-type">积分制</span>。词语个数：3个。</div>
        <div class="tab-desc">2、选择考场后即可开始比赛。</div>
        <div class="tab-desc">3、批量修改晋级，需要先导出全部成绩信息，修改完成后再导入文件</div>
      </el-tab-pane>
    </el-tabs>
    <template v-if="activeName === '1-A' || activeName === '2-A'">
      <GroupA ref="GroupA" :flag="activeName"></GroupA>
    </template>
    <template v-if="activeName === '1-B' || activeName === '3'">
      <GroupB ref="GroupB" :flag="activeName"></GroupB>
    </template>
    <template v-if="activeName === '1-C'">
      <!-- 小组赛单轮淘汰 -->
      <!-- <GroupC ref="GroupC" :flag="activeName"></GroupC> -->
      <GroupSingleRound ref="GroupSingleRound" :flag="activeName"></GroupSingleRound>
    </template>
    <template v-if="activeName === '1-C-1'">
      <!-- 小组赛单轮淘汰 -->
      <GroupC ref="GroupC" :flag="activeName"></GroupC>
      <!-- <GroupSingleRound ref="GroupSingleRound" :flag="activeName"></GroupSingleRound> -->
    </template>
    <template v-if="activeName === '2-B-1'">
      <!-- 无组别单轮淘汰 -->
      <GroupC ref="GroupC" :flag="activeName"></GroupC>
    </template>
    <template v-if="activeName === '2-B'">
      <FinalSingleRound ref="FinalSingleRound" :flag="activeName"></FinalSingleRound>
    </template>
    <template v-if="activeName === '4' || activeName === '4'">
      <GroupD ref="Group" :flag="activeName"></GroupD>
    </template>
    <template v-if="activeName === '3-B'">
      <GroupE ref="GroupE" :flag="activeName"></GroupE>
    </template>
    <template v-if="activeName === '3-C'">
      <GroupF ref="GroupF" :flag="activeName"></GroupF>
    </template>
      <template v-if="activeName === '3-D'">
      <GroupG ref="GroupG" :flag="activeName"></GroupG>
    </template>
  </div>
</template>
<script>
import GroupA from './groupA.vue'
import GroupB from './groupB.vue'
import GroupC from './groupC.vue'
import GroupD from './groupD.vue'
import GroupE from './groupE.vue'
import GroupF from './groupF.vue'
import GroupG from './groupG.vue'
import GroupSingleRound from './singleRoundGroup.vue'
import FinalSingleRound from './singleRoundFinal.vue'

export default {
  name: 'referee',
  components: {
    // GroupC
    GroupA, GroupB, GroupD, GroupE, GroupF, GroupG, GroupSingleRound, GroupC, FinalSingleRound
  },
  data () {
    return {
      activeName: '1-A',
      group: 1
    }
  },
  created () {
    const flag = this.$route.query.flag
    this.activeName = flag
    this.group = Number(this.$route.query.group)
    this.phase = Number(this.$route.query.phase)
    if (!flag) {
      // 根据 phase 参数设置默认 tab
      if (this.group === 3) {
        if (this.phase === 1) {
          this.activeName = '3-B'
        } else if (this.phase === 2) {
          this.activeName = '3-C'
        } else if (this.phase === 3) {
          this.activeName = '3-D'
        } else {
          this.activeName = '3-B' // 默认值
        }
      } else {
        this.activeName = this.group === 1 ? '1-A' : this.group === 2 ? '2-A' : this.group === 4 ? '4' : '1-A'
      }
    } else {
    }
    this.handleClick()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleClick () {
      console.log('handleClick - activeName:', this.activeName)
      setTimeout(() => {
        if (this.activeName === '3') { // 复选（2022～2023）
          this.$refs.GroupB.init3()
        } else if (this.activeName === '3-B') { // 复选（2023～2024+）
          this.phase = 1
          this.$refs.GroupE.init3B()
        } else if (this.activeName === '3-C') { // 复选第二轮（2023～2024+）
          this.phase = 2
          this.$refs.GroupF.init3C()
        } else if (this.activeName === '3-D') { // 复选第二轮（2023～2024+）
          this.phase = 3
          this.$refs.GroupG.init3D()
        } else if (this.activeName === '1-B') {
          this.$refs.GroupB.init1B()
        } else if (this.activeName === '1-A' || this.activeName === '2-A') {
          this.$refs.GroupA.init()
        } else if (this.activeName === '1-C') {
          this.$refs.GroupSingleRound.init1C()
        } else if (this.activeName === '1-C-1') {
          this.$refs.GroupC.init1C()
        } else if (this.activeName === '2-B-1') {
          this.$refs.GroupC.init2B()
        } else if (this.activeName === '2-B') {
          this.$refs.FinalSingleRound.init()
        }
      })
    },
    copyFn (type) {
      var loc = window.location.origin
      var input = document.createElement('input') // 创建input标签
      if (type === 'h5') {
        this.doCopy('stuLogin')
      } else if (type === 'rank') {
        if (!this.$refs.GroupE.examRoomId) return this.$message.warning('请选择考场')
        const query = {
          activityType: this.$refs.GroupE.queryForm.activityType,
          season: this.$refs.GroupE.queryForm.season,
          raceSchedule: this.$refs.GroupE.queryForm.raceSchedule,
          phase: this.phase,
          examinationRoomId: this.$refs.GroupE.examRoomId,
          isShowScore: 1
        }

        input.value = `${loc}/#/semiRank?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
        document.body.appendChild(input) // 添加input标签
        input.select() // 选中input标签
        document.execCommand('copy') // 执行复制
        this.$message.success('复制成功') // 成功提示信息
        document.body.removeChild(input) // 移除input标签
        // this.doCopy(`semiRank?season=${this.$refs.GroupE.queryForm.season}&raceSchedule=${this.$refs.GroupE.queryForm.raceSchedule}&examinationId=${this.$refs.GroupE.examRoomId}&phase=${this.phase}`)
      }
      //  else if (type === 'answer') {
      //   const query = {
      //     activityType: this.$refs.GroupE.queryForm.activityType,
      //     season: this.$refs.GroupE.queryForm.season,
      //     group: this.group,
      //     raceSchedule: this.$refs.GroupE.queryForm.raceSchedule,
      //     phase: this.phase,
      //     examinationRoomId: this.$refs.GroupE.examRoomId
      //   }
      //   input.value = `${loc}/#/pad/semiScreen?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      //   document.body.appendChild(input) // 添加input标签
      //   input.select() // 选中input标签
      //   document.execCommand('copy') // 执行复制
      //   this.$message.success('复制成功') // 成功提示信息
      //   document.body.removeChild(input) // 移除input标签
      // }
    },
    doCopy (url) {
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin

      input.value = `${loc}/#/${url}` // 将input的值设置为需要复制的内容
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    }
  }
}
</script>
<style lang="less" scoped>
  .tab-desc{
    font-size: 14px;
    margin-bottom: 4px;
    .btn{
      color: #409EFF;
      text-decoration: underline;
      cursor: pointer;
      margin-right: 20px;
    }
  }
  .tab-form{
    font-size: 14px;
    margin-top: 24px;
    padding-top: 15px;
    border-top: 1px solid #E4E7ED;
  }
  .exam-type{
    color: #409EFF;
    font-size: 16px;
    font-weight: bold;
  }
</style>
